import { LegendParameters } from '@components/mainmap/legend/LegendParameters'

export interface ScaleValue {
  min?: number
  max?: number
  value: string
}

export namespace ScaleValue {
  export function toLegendParameters(
    scaleValues: ScaleValue[],
    units?: string
  ) {
    const intervals: number[] = []
    const colors: string[] = []

    for (const scaleValue of scaleValues) {
      if (scaleValue.min !== undefined) {
        intervals.push(scaleValue.min)
      }
      if (scaleValue.max !== undefined) {
        intervals.push(scaleValue.max)
      }

      colors.push(scaleValue.value)
    }

    const legendParameters = new LegendParameters(
      Array.from(new Set(intervals)),
      colors,
      'intervals'
    )
    legendParameters.outRangeMin = scaleValues[0].min === undefined
    legendParameters.outRangeMax =
      scaleValues[scaleValues.length - 1].max === undefined

    legendParameters.units = units
    return legendParameters
  }
}
